import css from 'styled-jsx/css';
import { colors, zIndexLevels, animationDuration } from '../../../../../themes';

export default css`
  form {
    background: #fff;
    height: 100%;
    left: 110%;
    overflow: auto;
    padding: 75px 15px 85px;
    position: fixed;
    will-change: left;
    top: 0;
    width: 100%;
    z-index: ${zIndexLevels.high5};
  }

  form.animated {
    transition: left ${animationDuration.fast}s ease-in-out;
  }

  form.shown {
    left: 0;
  }

  .header {
    background: ${colors.blue};
    color: #fff;
    left: 110%;
    padding: 20px 15px;
    position: fixed;
    will-change: left;
    top: 0;
    width: 100%;
    z-index: calc(${zIndexLevels.high5} - 1);
  }

  :global(.rtl) .header {
    left: auto;
    right: 110%;
    transition: right ${animationDuration.fast}s ease-in-out;
    will-change: right;
  }

  form.animated .header {
    transition: left ${animationDuration.fast}s ease-in-out;
  }

  form.shown .header {
    left: 0;
  }

  :global(.rtl) form.animated .header {
    transition: right ${animationDuration.fast}s ease-in-out;
  }

  .title {
    display: inline;
    font-size: 1em; /* 16/16 */
    font-weight: bold;
    text-transform: uppercase;
  }

  .cancel {
    color: #fff;
    float: left;
    margin: -2px 15px 0 -5px;
  }

  .clear {
    color: ${colors.blueLight};
    float: right;
  }

  .buttons {
    bottom: 0;
    left: 110%;
    background: #fff;
    border-top: 1px solid ${colors.grayLight};
    padding: 15px;
    position: fixed;
    will-change: left;
    width: 100%;
  }

  :global(.rtl) .buttons {
    left: auto;
    right: 110%;
    transition: right ${animationDuration.fast}s ease-in-out;
    will-change: right;
  }

  form.animated .buttons {
    transition: left ${animationDuration.fast}s ease-in-out;
  }

  form.shown .buttons {
    left: 0;
  }

  :global(.rtl) form.animated .buttons {
    transition: right ${animationDuration.fast}s ease-in-out;
  }

  .fetching {
    background: rgba(255, 255, 255, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  :global(.rtl) form.shown .buttons {
    left: auto;
    right: 0;
  }

  :global(.rtl) form {
    left: auto;
    right: 110%;
    transition: right ${animationDuration.fast}s ease-in-out;
    will-change: right;
  }

  :global(.rtl) form.animated {
    transition: right ${animationDuration.fast}s ease-in-out;
  }

  :global(.rtl) form.shown {
    left: auto;
    right: 0;
  }

  :global(.rtl) form.shown .header {
    left: auto;
    right: 0;
  }

  :global(.rtl) .cancel {
    float: right;
    transform: scaleX(-1);
    margin: -2px -5px 0 15px;
  }

  :global(.rtl) .clear {
    float: left;
  }
`;



// WEBPACK FOOTER //
// ./app/Serp/components/Filters/shared/Form/styles.js